import { PATH_CHANGE, PATH_INITIALIZE } from "actions/types";

export function initPrevPath() {
  return { type: PATH_INITIALIZE };
}

export function setPath(path) {
  return { type: PATH_CHANGE, payload: { path } };
}
